import styled from 'styled-components'

export const Nav = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 16px 60px;
	border-radius: 0px 0px 3px 3px;
	background: rgb(17, 141, 255);
`

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
`

export const Link = styled.a`
	letter-spacing: 0.05em;
	color: #fff;
	font-family: Proxima Nova;
	font-size: 18px;
	font-weight: 700;
`
